export default __webpack_public_path__ + "static/ArchicadIcon-e730cd7f26bcd42b21148030e19809ce.png";